import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-ca-footer',
    templateUrl: './ca-footer.component.html',
    styleUrls: ['./ca-footer.component.scss'],
    standalone: false
})
export class CaFooterComponent implements OnInit {

  priceStated : string = "Price stated may be subject to Service Tax";
  maxisCopyright: string = "Copyright © 2022 Maxis Bhd. All rights reserved.";
  redressYourComplaints: string = "Redress your complaints at the Consumer Forum Malaysia (CFM)   |   www.complaint.cfm.org.my";

  constructor() { }

  ngOnInit(): void {
  }

}
